module.exports = __webpack_public_path__ + "static/media/shield-check.e30c0ca5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/icons/shield-check.svg
// module id = 319
// module chunks = 0